module.exports = __webpack_public_path__ + "static/img/TSRC.74218889.png";